// assets
export const logo = 'https://firebasestorage.googleapis.com/v0/b/realtor-rewards-staging.firebasestorage.app/o/app-assets%2FRealtorRewardsLogo.svg?alt=media&token=b5c467cc-b9e5-4792-a6fa-3409a3654294'
export const fullLogo = 'https://firebasestorage.googleapis.com/v0/b/realtor-rewards-staging.firebasestorage.app/o/app-assets%2FRealtorRewardsFullLogo.svg?alt=media&token=6d067cad-22ad-4d33-9bbd-ad6a4ac7f461'
export const companyCodeDarkImage = 'https://firebasestorage.googleapis.com/v0/b/realtor-rewards-staging.firebasestorage.app/o/app-assets%2FcompanyCodeImage.webp?alt=media&token=cfc1a0bf-7750-4b1a-bb13-c00e3dbbf34a'
export const companyCodeLightImage = 'https://firebasestorage.googleapis.com/v0/b/realtor-rewards-staging.firebasestorage.app/o/app-assets%2FcompanyCodeLightImage.webp?alt=media&token=42eb6c48-466b-4c45-bd00-a4d21204f069'
export const sampleCSVFile = 'https://firebasestorage.googleapis.com/v0/b/realtor-rewards-staging.firebasestorage.app/o/CSVSample%2FExampleCSV-File.csv?alt=media&token=ee73b1d1-a45b-4ddd-a949-fef38d89320e'

// page URLs
export const loginPage = '/Login'
export const resetPasswordURL = '/resetPassword'
export const createAccountPage = '/createAccount/:companyCode?'
export const createCompanyPage = '/createCompanyAccount'
export const accountActivation = '/activate'
export const realtorsPage = '/realtors'
export const realtorPage = '/realtor/:realtorID'
export const profilePage = '/profile'
export const manageUsersPage = '/manageUsers'
export const clientRegistrationPageURL = '/clientRegistration'
export const adminClientRegistrationPageURL = '/viewClientRegistrations'
export const regionsURL = '/regions'
export const communitiesURL = '/communities'
export const rewardsURL = '/rewards'
export const bonusLevelURL = '/bonusLevel'
export const unclaimedPointsURL = '/unclaimedPoints'
export const assignedToMeURL = '/assignedToMe'
export const autoNotificationsURL = '/autoNotifications'
export const notificationsURL = '/notifications'
export const notificationURL = '/notifications/:id'
export const notificationCampaignsURL = '/campaigns'
export const eventsURL = '/events'
export const myPointsURL = '/myPoints'
export const pointsReportsURL = '/pointsReports'
export const completeProdileURL = '/completeProfile'
export const adminSettingsURL = '/adminSettings'
export const informationURL = '/information'
export const notAuthorized = '/notAuthorized'
export const notFound404 = '/notFound404'
export const testPage = '/test'

export const footerHeight = 70
export const drawerWidth = 240

export const toolTipTimeButton = 300
export const toolTipTimeTable = 300
export const toolTipSidebar = 600
export const toastHideduration = 6000
